export const pages = {
  root: '/',
  defaultRoute: '/authentication/sign-in',
  login: '/authentication/sign-in',
  signIn: '/authentication/sign-up',
  resetRequest: '/authentication/request-reset-password',
  firstLogin: '/authentication/first',
  resetPassword: '/reset-password/:token',
  home: '/home',
  accessDenied: '/access-denied',
  messaging: '/messagerie',
  about: '/about',

  smartPlanning: '/smart-planning',
  programRecap: '/smart-planning/recap',
  programNurseRecap: '/smart-planning/nurse-recap',
  weekVue: '/smart-planning/week-vue',
  myProgram: '/smart-planning/my-program',

  pendingRequests: 'pending-requests',
  pendingRequestsHome: '/pending-requests/home',
  fullscreenHome: '/pending-requests/home/fullscreen',

  hrSuite: '/hrsuite/',
  hrSuiteListe: '/hrsuite/liste',
  hrsuiteNurse: '/hrsuite/liste/Infirmiere',
  hrsuiteAnesthesiste: '/hrsuite/liste/Anesthesiste',
  indivdualCalendar: '/profiles/current',
  statOp: '/statop',
  profile: '/profile',
  profiles: '/profiles',
  anesthesistes: '/hrsuite/liste/Anesthesiste',
  demandeRhAnesthesiste: '/hrsuite/demande-rh-anesthesiste',
  nurses: '/hrsuite/liste/Infirmiere',
  demandeRhInfirmiere: '/hrsuite/demande-rh-infirmiere',
  commissionRegulation: '/hrsuite/commission-regulation',
  demandeRh: '/hrsuite/demande-rh',
  demandeRhHistory: '/hrsuite/demande-rh/history',
  demandeRhValidation: '/hrsuite/demande-rh/validation',
  demandeRhHistoryValidation: '/hrsuite/demande-rh/history/validation',
  demandeRhVacationRoot: '/hrsuite/demande-rh/vacataire-validation',
  demandeRhHistoryVacation: '/hrsuite/demande-rh/history/vacataire-validation',
  demandeRhSwitch: '/hrsuite/demande-rh/switch',
  demandeRhHistorySwitch: '/hrsuite/demande-rh/history/switch',
  demandeRhCampaign: '/hrsuite/campaigns',
  hrsuiteBesoinsGarde: '/hrsuite/besoinsgarde',
  hrsuiteSimpleDayNeeds: '/hrsuite/simpledayneeds',
  statsRh: '/hrsuite/stats-rh',

  operatingSchedule: '/operatingschedule/',
  parPraticiens: '/operatingschedule/Chirurgien/par-praticiens',
  demandeRhVacation: '/operatingschedule/demande-rh/vacataire-validation/Chirurgien',
  demandeRhHistoryVacationSurgeons: '/operatingschedule/demande-rh/vacataire-validation/Chirurgien/history',

  parSalles: '/operatingschedule/Chirurgien/par-salles',
  sallesDeSurveillance: '/operatingschedule/Chirurgien/salles-de-surveillance',
  parSallesBesoins: '/operatingschedule/Chirurgien/besoins',
  parInterventions: '/operatingschedule/Chirurgien/par-interventions',
  parProfile: '/operatingschedule/Chirurgien/profile',

  comptenceIndividuelle: '/parcours-ibode/competence/competence-individuelle',
  parcoursIbode: '/parcours-ibode/competence',
  parcoursIbodeCompetencesTable: '/parcours-ibode/competence/tableau-competences',
  parcoursIbodeCurrent: '/parcours-ibode/competence/competence-individuelle/current',
  parcoursIbodeIndividual: '/parcours-ibode/competence/competence-individuelle',
  intervention: '/parcours-ibode/contenu/interventions',
  materials: '/parcours-ibode/contenu/materiels',
  individualParcours: '/parcours-ibode/contenu',

  statopBloc: '/statop/bloc',
  statopBlocGeneral: '/statop/bloc/general',
  statopBlocParPraticien: '/statop/bloc/par-praticien',
  statopAnesthesiste: '/statop/anesthesiste',
  statopAnesthesisteGeneral: '/statop/anesthesiste/general',
  statopAnesthesisteParAnesthesiste: '/statop/anesthesiste/par-anesthesiste',
  statopCA: '/statop/anesthesiste/turnover',

  configuration: '/configuration/general',
  besoins: '/configuration/besoins',
  besoinsGarde: '/configuration/besoinsgarde',
  tvo: '/configuration/tvo',
  cyclePlanning: '/configuration/cycle-planning',

  configurationPreference: '/configuration/preference',
  jobDescription: '/configuration/advanced/fiche-poste',
  configurationStructure: '/configuration/advanced/general',
  configurationProfiles: '/configuration/advanced/profiles',
  configurationRH: '/configuration/advanced/rh',
  matchingResults: '/configuration/advanced/matchingresults',
  reasonsMaps: '/configuration/advanced/reasons-maps',
};
